"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContainer = exports.Bouncer = exports.AnimationContainer = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _designTokens = require("@decisiv/design-tokens");

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var CONTAINER_STYLE = {
  small: (0, _styledComponents.css)(["flex-direction:row;gap:", ";"], (0, _rem.default)(_designTokens.spacing.base * 0.5)),
  medium: (0, _styledComponents.css)(["flex-direction:column;align-items:center;gap:", ";"], (0, _rem.default)(_designTokens.spacing.base)),
  large: (0, _styledComponents.css)(["flex-direction:column;align-items:center;gap:", ";"], (0, _rem.default)(_designTokens.spacing.base))
};
var Container = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "styles__Container",
  componentId: "fjt04b-0"
})(["display:flex;", ";"], function (_ref) {
  var loadingSize = _ref.loadingSize;
  return CONTAINER_STYLE[loadingSize];
});
exports.Container = Container;
var ANIMATION_CONTAINER_STYLE = {
  small: (0, _styledComponents.css)(["width:", ";min-width:", ";height:", ";"], (0, _rem.default)(_designTokens.spacing.base * 1.6), (0, _rem.default)(_designTokens.spacing.base * 1.6), (0, _rem.default)(_designTokens.spacing.base * 1.6)),
  medium: (0, _styledComponents.css)(["width:", ";min-width:", ";height:", ";"], (0, _rem.default)(_designTokens.spacing.base * 3.6), (0, _rem.default)(_designTokens.spacing.base * 3.6), (0, _rem.default)(_designTokens.spacing.base * 3.6)),
  large: (0, _styledComponents.css)(["width:", ";min-width:", ";height:", ";"], (0, _rem.default)(_designTokens.spacing.base * 4.8), (0, _rem.default)(_designTokens.spacing.base * 4.8), (0, _rem.default)(_designTokens.spacing.base * 4.8))
};

var AnimationContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__AnimationContainer",
  componentId: "fjt04b-1"
})(["position:relative;", ""], function (_ref2) {
  var size = _ref2.size;
  return ANIMATION_CONTAINER_STYLE[size];
});

exports.AnimationContainer = AnimationContainer;

var Bouncer = _styledComponents.default.div.withConfig({
  displayName: "styles__Bouncer",
  componentId: "fjt04b-2"
})(["width:100%;height:100%;border-radius:50%;background-color:", ";opacity:0.6;position:absolute;top:0;left:0;animation:sk-bounce 2s infinite ease-in-out;", " ", " @keyframes sk-bounce{0%,100%{transform:scale(0);}50%{transform:scale(1);}}"], (0, _toColorString.default)(_designTokens.color.interaction.pacificOcean40), function (_ref3) {
  var inverted = _ref3.inverted;
  return inverted && (0, _styledComponents.css)(["background-color:", ";"], (0, _toColorString.default)(_designTokens.color.opacity.fullMoon50));
}, function (_ref4) {
  var shadow = _ref4.shadow;
  return shadow && (0, _styledComponents.css)(["animation-delay:-1s;"]);
});

exports.Bouncer = Bouncer;
var TEXT_CONTAINER_STYLE = {
  small: (0, _styledComponents.css)(["text-align:left;align-items:flex-start;"]),
  medium: (0, _styledComponents.css)(["gap:", ";text-align:center;align-items:center;"], (0, _rem.default)(_designTokens.spacing.base * 0.5)),
  large: (0, _styledComponents.css)(["gap:", ";text-align:center;align-items:center;"], (0, _rem.default)(_designTokens.spacing.base * 0.5))
};

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__TextContainer",
  componentId: "fjt04b-3"
})(["display:flex;flex-direction:column;", ";"], function (_ref5) {
  var size = _ref5.size;
  return TEXT_CONTAINER_STYLE[size];
});

exports.TextContainer = TextContainer;